import apiClient from './apiClient';

const API_URL = '/amparo-pnc/escrito';

// Alta: el trámite todavía no existe, se genera solo con lo que ya se tipeó en el formulario.
export const generarEscritoAmparoPncDesdeDatos = async (datos) => {
    try {
        const response = await apiClient.post(API_URL, datos, {
            responseType: 'blob',
        });
        return response;
    } catch (error) {
        console.error('❌ Error generando el escrito de Amparo PNC:', error);
        throw error;
    }
};

// Ficha: genera desde el trámite ya guardado y lo adjunta a sus Archivos.
export const generarEscritoAmparoPncTramite = async (idTramite) => {
    try {
        const response = await apiClient.post(`${API_URL}/tramite/${idTramite}`, null, {
            responseType: 'blob',
        });
        return response;
    } catch (error) {
        console.error('❌ Error generando el escrito de Amparo PNC:', error);
        throw error;
    }
};
